import { useEffect } from 'react';
import { postWithToken } from 'utility';

const SDK_SCRIPT_ID = 'chatsystem-customer-widget-sdk';
export const CHAT_VISITOR_STORAGE_KEY = 'chat_plugin_visitor_id';

export const removeCustomerChatWidget = async () => {
  if (window.ChatPluginSDK && typeof window.ChatPluginSDK.destroy === 'function') {
    await window.ChatPluginSDK.destroy();
  }
  document.querySelectorAll('.chat-plugin-launcher, .chat-plugin-iframe').forEach((node) => {
    node.parentNode && node.parentNode.removeChild(node);
  });
};

export const resetCustomerChatSession = async () => {
  await removeCustomerChatWidget();
  if (localStorage.getItem('customerPortalToken')) {
    const response = await postWithToken('/chat/logout');
    if (!response.ok && response.status !== 401) throw new Error('Chat logout failed');
  }
  window.sessionStorage.removeItem(CHAT_VISITOR_STORAGE_KEY);
  localStorage.removeItem('customerPortalToken');
};

const initWidget = async ({ orgId, widgetUrl, customerToken }, isCurrent = () => true) => {
  if (!orgId || !customerToken) return;

  await removeCustomerChatWidget();

  const runInit = () => {
    if (!isCurrent() || !window.ChatPluginSDK || typeof window.ChatPluginSDK.init !== 'function') return;
    window.ChatPluginSDK.init({
      orgId,
      widgetUrl,
      customerToken
    });
  };

  const existingScript = document.getElementById(SDK_SCRIPT_ID);
  if (existingScript) {
    if (window.ChatPluginSDK) runInit();
    else existingScript.addEventListener('load', runInit, { once: true });
    return;
  }

  const script = document.createElement('script');
  script.id = SDK_SCRIPT_ID;
  script.src = `${String(widgetUrl || 'https://origin.longwind.us/widget').replace(/\/+$/, '')}/chat-sdk.js`;
  script.async = true;
  script.onload = runInit;
  document.head.appendChild(script);
};

const CustomerChatWidget = () => {
  useEffect(() => {
    let disposed = false;

    postWithToken('/chat/customer-token')
      .then(async (res) => {
        if (!res.ok || disposed) return;
        const data = await res.json();
        if (!disposed) {
          await initWidget(data, () => !disposed);
        }
      })
      .catch((err) => {
        console.warn('Unable to initialize customer chat widget', err);
      });

    const onStorage = (event) => {
      if (event.key === 'customerPortalToken' || event.key === null) {
        disposed = true;
        removeCustomerChatWidget();
        window.sessionStorage.removeItem(CHAT_VISITOR_STORAGE_KEY);
      }
    };
    window.addEventListener('storage', onStorage);
    return () => {
      window.removeEventListener('storage', onStorage);
      disposed = true;
      removeCustomerChatWidget();
    };
  }, []);

  return null;
};

export default CustomerChatWidget;
